import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { FilterDataType, SimpleDataFilter } from 'src/app/models/simpleDataFilter';
import { FilteringService } from 'src/app/services/filtering.service';
import { InvoiceHistoryService } from 'src/app/services/invoice-history.service';
import { PaginationEventData } from 'src/app/shared-components-module/pagination-top/models/paginationEventData';
import { InvoiceFilter } from '../models/InvoiceFilter';

@Component({
  selector: 'app-invoice-list',
  templateUrl: './invoice-list.component.html',
  styleUrls: ['./invoice-list.component.less']
})
export class InvoiceListComponent implements OnInit, OnDestroy, AfterViewInit {
  $invoicesLoaded: Subscription;
  loaded: boolean = false;
  displayFilters: boolean = true;

  constructor(public invoices: InvoiceHistoryService, public filtering: FilteringService) 
  { }
  ngAfterViewInit(): void {
    document.getElementById('filterPanel').addEventListener('keypress', ev => {
      this.handleKeypress(ev);
    });
  }
  ngOnDestroy(): void {
    this.$invoicesLoaded.unsubscribe();

  }

  ngOnInit() {
    this.$invoicesLoaded = this.invoices.$loadingInvoiceHistory.subscribe(res => {
      this.loaded = true;
    });
    
  }

  public applyFilters(): void {
    this.invoices.invoiceList = [];
    this.invoices.fetchInvoiceList(this.invoices.invoiceFilter);
  }

  public clearFilters(): void {
    this.invoices.invoiceFilter = new InvoiceFilter();
    this.invoices.invoiceList = [];
    this.filtering.filters = [];
    this.invoices.fetchInvoiceList();
  }

  public onPaginationChanged(event: PaginationEventData) {
    this.invoices.invoiceList = [];
    this.invoices.fetchInvoiceList(this.invoices.invoiceFilter);
    this.filtering.clearTransientFilters();
  }

  showFilters(): void {
    this.displayFilters = !this.displayFilters;
  }


  handleKeypress(ev: KeyboardEvent): void {
    if(ev.key === 'Enter') this.applyFilters();
  }

}
